import React, { useEffect, useState } from "react";
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import { Loader } from "../../../components/loader";
import { acceptReq, getWithdowlList } from "../../../action/contest";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { Modal } from "react-bootstrap";
import showNotification from "../../../components/notification/showNotification";
const WithdrowlList = () => {
  const [pageSize, setPageSize] = useState(10);
  const [pageNo, setPageNo] = useState(1);
  const [totalData, setTotalData] = useState(null);
  const [WithdrowlDataList, setWithdrowlDataList] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [status, setstatus] = useState(0);
  const [tabIndex, setTabIndex] = useState(0);
  const [acceptmodel, setAcceptmodel] = useState(false);
  const [payload, setPayload] = useState({
    status: "",
    userId: "",
    upiId: "",
  });
  const getwithdowlList = async (page) => {
    try {
      setIsLoading(true);
      const response = await getWithdowlList(page, pageSize, status); // Adjust 10 to the desired number of items per page
      if (response.status) {
        setWithdrowlDataList(response.data);
        setTotalData(response.data.count);
        setIsLoading(false);
        console.log("withdrawl", response.data);
        console.log("withdrawl status", response.data);
      }
    } catch (error) {
      console.error("Failed to fetch category data", error);
    }
  };
  const acceptRequest = async () => {
    try {
      setIsLoading(true);
      const response = await acceptReq(payload);
      if (response.status) {
        showNotification(
          "Success",
          "Request accepted successfully!",
          "success"
        );
        setAcceptmodel(false);
        setstatus(1);
        setTabIndex(1);
      }
    } catch (error) {
      console.error("Failed to fetch category data", error);
    }
  };
  useEffect(() => {
    getwithdowlList(pageNo);
  }, [pageNo, pageSize, status]);
  return (
    <>
      <div className="payout_data-content">
        <div className="payout_data-head">
          <div className="payout_data-head-top mb-2">
            <div className="payout_data-left">
              <div className="payout_data_ttl">
                <Breadcrumb paths={[{ name: "Withdrawal List" }]} />
              </div>
            </div>
          </div>
        </div>
        <Tabs
          selectedIndex={tabIndex}
          onSelect={(index) => {
            setTabIndex(index);
            setstatus(index); // Update status based on selected tab
          }}>
          <TabList>
            <Tab
              onClick={() => {
                setstatus(0);
              }}>
              Pending Request
              {/* <div className="paymentHits">125</div> */}
            </Tab>
            <Tab
              onClick={() => {
                setstatus(1);
              }}>
              Confirmed Request
            </Tab>
          </TabList>
          <TabPanel>
            <table className="payout_table upi-mandate_table">
              <thead>
                <tr className="tableHead">
                  <th className="thHeader">
                    <div className="payoutHead hndIcon">Name</div>
                  </th>
                  <th className="thHeader">
                    <div className="payoutHead hndIcon">Mobile</div>
                  </th>
                  <th className="thHeader">
                    <div className="payoutHead hndIcon">Email</div>
                  </th>
                  <th className="thHeader">
                    <div className="payoutHead hndIcon">Amount</div>
                  </th>
                  <th className="thHeader">
                    <div className="payoutHead hndIcon">UPI ID</div>
                  </th>
                  <th className="thHeader">
                    <div className="payoutHead hndIcon">Action</div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  <tr>
                    <td colSpan="15">
                      <Loader />
                    </td>
                  </tr>
                ) : (
                  <>
                    {WithdrowlDataList?.length > 0 ? (
                      WithdrowlDataList?.map((item) => (
                        <tr key={item._id}>
                          <td>{item?.userInfo?.name}</td>
                          <td>{item?.userInfo?.mobile}</td>
                          <td>
                            {item?.userInfo?.email.length
                              ? item?.userInfo?.email
                              : "-"}
                          </td>
                          <td>
                            {" "}
                            {"₹"} {item?.amount}
                          </td>
                          <td>{item?.userInfo?.paymentInfo?.upiId} </td>

                          <td>
                            <button
                              className="btn btn-primary"
                              onClick={() => {
                                setPayload({
                                  status: 1,
                                  userId: item?.userId,
                                  upiId: item?.userInfo?.paymentInfo?.upiId,
                                });
                                setAcceptmodel(true);
                              }}>
                              {" "}
                              Accept
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan="15"
                          className="text_center">
                          No data available
                        </td>
                      </tr>
                    )}
                  </>
                )}
              </tbody>
            </table>
          </TabPanel>
          <TabPanel>
            <table className="payout_table upi-mandate_table">
              <thead>
                <tr className="tableHead">
                  <th className="thHeader">
                    <div className="payoutHead hndIcon">Name</div>
                  </th>
                  <th className="thHeader">
                    <div className="payoutHead hndIcon">Mobile</div>
                  </th>
                  <th className="thHeader">
                    <div className="payoutHead hndIcon">Email</div>
                  </th>
                  <th className="thHeader">
                    <div className="payoutHead hndIcon">Amount</div>
                  </th>
                  <th className="thHeader">
                    <div className="payoutHead hndIcon">UPI ID</div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  <tr>
                    <td colSpan="15">
                      <Loader />
                    </td>
                  </tr>
                ) : (
                  <>
                    {WithdrowlDataList?.length > 0 ? (
                      WithdrowlDataList?.map((item) => (
                        <tr key={item._id}>
                          <td>{item?.userInfo?.name}</td>
                          <td>{item?.userInfo?.mobile}</td>
                          <td>
                            {item?.userInfo?.email.length
                              ? item?.userInfo?.email
                              : "-"}
                          </td>
                          <td>
                            {" "}
                            {"₹"} {item?.amount}
                          </td>
                          <td>{item?.userInfo?.paymentInfo?.upiId} </td>

                          {/* <td className="three_btn">
                              <Link to={`/contest/list/${item._id}`}>
                                <img
                                  src={contestIcon}
                                  alt="/"
                                />
                              </Link>
                              <Link to={`/module/edit/${item._id}`}>
                                <img
                                  src={editIcon}
                                  alt="Edit icon"
                                />
                              </Link>
                              <img
                                src={trashIcon}
                                style={{
                                  height: "26px",
                                }}
                                alt="delete icon"
                              />
                            </td> */}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan="15"
                          className="text_center">
                          No data available
                        </td>
                      </tr>
                    )}
                  </>
                )}
              </tbody>
            </table>
          </TabPanel>
        </Tabs>
      </div>
      <Modal show={acceptmodel}>
        <Modal.Header>
          <Modal.Title>
            Are you sure you want to withdrawal this request?{" "}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <span>Please confirm your details before saving</span>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-dark"
            variant="secondary"
            onClick={() => setAcceptmodel(false)}>
            Cancel
          </button>
          <button
            className="btn btn-success"
            variant="primary"
            onClick={() => {
              acceptRequest();
            }}>
            Confirm
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default WithdrowlList;
